export enum IdSchemaEnum {
    NATIVE = 'native',
    ENETPULSE = 'enetpulse',
    SPORTRADAR = 'sportradar',
    SPORTAL_365 = 'sportal365'
}